interface ITime {
  hour: number
  minute: number
  second: number
}

export const TIME_FORMAT = 'HH:mm:ss'

export function normalizeTime(time: string) {
  const { hour, minute, second } = parseTime(time)

  return `${padTimePart(hour)}:${padTimePart(minute)}:${padTimePart(second)}`
}

// time: 'HH:MM:SS' | 'HH:MM:SS.SSSSSS' (with microseconds up to 6 digits precision)
export function parseTime(time: string): ITime {
  const matches = time.match(/^(\d\d):(\d\d):(\d\d)(?:.\d{1,6})?$/)
  if (!matches) {
    throw parseError(time)
  }

  const hour = parseInt(matches[1], 10)
  if (Number.isNaN(hour)) {
    throw parseError(time)
  }

  const minute = parseInt(matches[2], 10)
  if (Number.isNaN(minute)) {
    throw parseError(time)
  }

  const second = parseInt(matches[3], 10)
  if (Number.isNaN(second)) {
    throw parseError(time)
  }

  return { hour, minute, second }
}

// time: 'HH:MM:SS' | 'HH:MM:SS.SSSSSS' (with microseconds up to 6 digits precision)
// Formats to 'h:mma' (i.e. 8:30am)
export function formatTime(time: string) {
  const { hour, minute } = parseTime(time)
  const h = hour > 12 ? hour - 12 : hour
  const mm = padTimePart(minute)
  const a = hour < 12 ? 'am' : 'pm'

  return `${h === 0 ? 12 : h}:${mm}${a}`
}

export function padTimePart(part: number) {
  return part < 10 ? `0${part}` : part
}

function parseError(time: string) {
  return new Error(`failed to parse time: ${time}`)
}
